import React from 'react'
import { Button, Icon, Checkbox } from 'antd'
import prettysize from '../../utils'
import './styles.scss'

export default ({file,  on_select, use_weblink, on_copy_link, on_generate_link }) => {
  let {basename, size, type, generating_link, download_url} = file

  return (
    <div className='share-item columnWrap'>
      <div>
        <Checkbox checked={file.share} onChange={(e)=> on_select(file, e.target.checked)}/>
        { type === 'FS_FILE_TYPE_FILE' ? <Icon type="file-text"/> : <Icon type="folder" />}
      </div>

      <div>
        <span>{basename} </span>
        <span>{prettysize(size)}</span>
      </div>

      {
        use_weblink ?
           null :
          <Button icon="copy" size={'small'} loading={generating_link} disabled={generating_link} onClick={() => download_url ? on_copy_link(file) : on_generate_link(file)}>
            {download_url ? 'Copy Link': 'Generate Link' }
          </Button>
      }

    </div>
  )
}


